/* eslint-disable react/no-array-index-key */
import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, Box, Paper, TextField } from '@mui/material';
import _ from 'lodash';
import './styles.scss';

const CreatePaper = forwardRef(({ children, createForm }, ref) => (
  <Paper ref={ref} className="select-with-create__paper" elevation={8}>
    {children}
    {createForm}
  </Paper>
));

CreatePaper.displayName = 'CreatePaper';

CreatePaper.propTypes = {
  children: PropTypes.node,
  createForm: PropTypes.node,
};

function SelectWithSearch(props) {
  const { selected, options, groupCreative, placeholder, onChange, field, createFormComponent: CreateForm } = props;
  const [value, setValue] = useState(selected || null);
  const [inputValue, setInputValue] = useState(selected && selected.label ? selected.label : '');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (selected === '') {
      setValue(null);
      setInputValue('');
    } else {
      setValue(selected || null);
      setInputValue(selected && selected.label ? selected.label : '');
    }
  }, [selected]);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Autocomplete
      id={_.kebabCase(placeholder)}
      className="select-with-create"
      open={open}
      onOpen={() => setOpen(true)}
      onClose={onClose}
      value={value}
      inputValue={inputValue}
      options={options}
      getOptionLabel={(option) => option?.label || ''}
      getOptionDisabled={(option) => option.disabled || false}
      isOptionEqualToValue={(option, selectedOption) => option.value === selectedOption?.value}
      onInputChange={(event, nextInputValue, reason) => {
        if (reason !== 'reset') {
          setInputValue(nextInputValue);
        }
      }}
      onChange={(event, nextValue) => {
        if (!nextValue) return;
        setValue(nextValue);
        setInputValue(nextValue.label);
        onChange(nextValue);
      }}
      PaperComponent={(paperProps) => (
        <CreatePaper
          {...paperProps}
          createForm={groupCreative && CreateForm ? <CreateForm field={field} closeField={onClose} /> : null}
        />
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
          }}
        />
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props} className="wedge-menu-item">
          {option.icon ? (
            <div>
              <div className="imgContainer">
                <img height={24} src={option.icon} alt={option.label} />
              </div>
              <span>{option.label}</span>
            </div>
          ) : (
            <span title={option.label}>{option.label}</span>
          )}
        </Box>
      )}
    />
  );
}

SelectWithSearch.propTypes = {
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.array.isRequired,
  groupCreative: PropTypes.bool.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  field: PropTypes.string,
  createFormComponent: PropTypes.any,
};

export default SelectWithSearch;
